import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';

const COMPONENT_NAME = 'TrackSignupSigninView';

type SignupSigninView = 'signup' | 'signin';

export interface IProps {
  view: SignupSigninView;
  source: string;
}

export default function TrackSignupSigninView({ view, source }: IProps) {
  const shouldTrack = useExpEnabled(experiments.CORE_SIGNUP_SIGNIN_VIEW_TRACKING);

  useViewTracking({
    view,
    source,
    eventName: MParticleEventName.ViewedSignupSignin,
    componentName: COMPONENT_NAME,
  }, shouldTrack);

  return null;
}
